// extracted by mini-css-extract-plugin
module.exports = {"loadingIcon":"kiosk-loading_loadingIcon_3eaRh","clearfix":"kiosk-loading_clearfix_2i1Kt"};